// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0bf2aebb","667":"63280ae7","977":"f12a053a"}[chunkId] + ".chunk.js";
};